import React from 'react';

export default ({
  classes,
  mwRedirectEmail,
  autogeneratedMWEmail,
}) => {

  return (
    <div className={classes.descriptionFont}>
      <li>Create a new mail flow rule in&nbsp;<strong>Exchange admin center:</strong></li>
      <li><strong>Tip: You must be an Exchange administrator or Global administrator in Microsoft 365 to do these steps.</strong></li>
      <li>1. <a href="https://admin.exchange.microsoft.com/" target="_blank" rel="noopener noreferrer" data-ylk="elm:context_link">https://admin.exchange.microsoft.com/</a>&nbsp;, go to the <strong>Mail flow</strong> page.</li>
      <li>2. On the <strong>Rules</strong> tab, select <strong>Add a rule</strong>.</li>
      <li>3. On the new transport rule page, name this new rule, select conditions and actions on this rule, such as the sender is In Organization, redirect the message to the personal account and type the&nbsp;{mwRedirectEmail ? mwRedirectEmail : autogeneratedMWEmail()}.</li>
      <li>4. Select <strong>Save changes</strong>.</li>
      <li className={`${classes.mt10} ${classes.mb10}`}>
        <img
          title='Microsoft 365 instruction'
          alt='Microsoft 365 instruction'
          width='100%'
          height='auto'
          border='none'
          src='/images/microsoft365.png'>
        </img>
      </li>
    </div>
  );
};
